package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.DisplayStyle

val LogoTextStyle = CssStyle {
    base {
        Modifier.display(DisplayStyle.Block)
    }

    cssRule("@media (max-width: 768px)") {
        Modifier.display(DisplayStyle.None)
    }
}